import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Button from "../../components/button";

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const EditConsultSequence = props => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(props.consults);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, props.consults);

  const onDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const itms = reorder(items, result.source.index, result.destination.index);

    setItems(itms);
  };

  return (
    <div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {items.map((item, index) => (
                <Draggable
                  key={item.id}
                  draggableId={item.id.toString()}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div>
                      <div
                        className="edit-seq-item"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        {item.content}
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <br />
      <p className="mb-0 d-flex justify-content-center">
        <Button
          clickEvent={() => {
            props.onUpdate(items);
          }}
          title="Update"
          type="button"
        />
      </p>
    </div>
  );
};

export default EditConsultSequence;

EditConsultSequence.defaultProps = {
  consults: [],
  onUpdate: () => {}
};

EditConsultSequence.propTypes = {
  consults: PropTypes.array,
  onUpdate: PropTypes.func
};
